module.exports = __webpack_public_path__ + "assets/logoPavRunner.3cec9d1a.png";